// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client'
import type {
  GetMeData,
  GetMeResponses,
  GetMeErrors,
  GetLoginIdentityProvidersData,
  GetLoginIdentityProvidersResponses,
  GetLoginIdentityProvidersErrors,
  LoginIdentityProviderData,
  LoginIdentityProviderResponses,
  LoginIdentityProviderErrors,
  LogoutData,
  LogoutErrors,
  GetSiteData,
  GetSiteResponses,
  GetSiteErrors,
  ListMapsData,
  ListMapsResponses,
  ListMapsErrors,
  GetMapData,
  GetMapResponses,
  GetMapErrors,
  ListDatasetsData,
  ListDatasetsResponses,
  ListDatasetsErrors
} from './types.gen'

import { client as _heyApiClient } from './client.gen'

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * Get the details of the logged in user
 * Returns the details of the logged in user.
 *
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/user',
    ...options
  })
}

/**
 * List available login methods
 * Returns the list of available login methods.
 *
 */
export const getLoginIdentityProviders = <ThrowOnError extends boolean = false>(options?: Options<GetLoginIdentityProvidersData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetLoginIdentityProvidersResponses, GetLoginIdentityProvidersErrors, ThrowOnError>({
    responseType: 'json',
    url: '/login',
    ...options
  })
}

/**
 * Login via the identity provider
 * Logs in a Site Administrator to the Site Manager using the identity provider and sets the Session.
 *
 */
export const loginIdentityProvider = <ThrowOnError extends boolean = false>(options: Options<LoginIdentityProviderData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<LoginIdentityProviderResponses, LoginIdentityProviderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/login/{identity_provider}',
    ...options
  })
}

/**
 * Logout
 * Logs out the user and clears the session.
 *
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).post<unknown, LogoutErrors, ThrowOnError>({
    url: '/logout',
    ...options
  })
}

/**
 * Get the details of the Site
 */
export const getSite = <ThrowOnError extends boolean = false>(options?: Options<GetSiteData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<GetSiteResponses, GetSiteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/site-details',
    ...options
  })
}

/**
 * List Maps
 * Returns the list of Maps that the user has access to. This means that unauthenticated users will only see public Maps, while authenticated users may see additional Maps based on their permissions.
 *
 */
export const listMaps = <ThrowOnError extends boolean = false>(options?: Options<ListMapsData, ThrowOnError>) => {
  return (options?.client ?? _heyApiClient).get<ListMapsResponses, ListMapsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/maps',
    ...options
  })
}

/**
 * Get the information of the Map
 */
export const getMap = <ThrowOnError extends boolean = false>(options: Options<GetMapData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<GetMapResponses, GetMapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/maps/{map_name}',
    ...options
  })
}

/**
 * List the Datasets available in the Map
 */
export const listDatasets = <ThrowOnError extends boolean = false>(options: Options<ListDatasetsData, ThrowOnError>) => {
  return (options.client ?? _heyApiClient).get<ListDatasetsResponses, ListDatasetsErrors, ThrowOnError>({
    responseType: 'json',
    url: '/maps/{map_name}/datasets',
    ...options
  })
}
